import React from "react";
import "../styles/Footer.scss";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="ovit-footer" id="foot">
      <div className="ovit-footer__bg" aria-hidden="true">
        <div className="ovit-footer__grid" />
        <div className="ovit-footer__glow ovit-footer__glow--1" />
        <div className="ovit-footer__glow ovit-footer__glow--2" />
      </div>

      <div className="ovit-footer__container">
        {/* Top CTA strip */}
        <div className="ovit-footer__cta">
          <div className="ovit-footer__ctaText">
            <h3>¿Listo para generar más ventas?</h3>
            <p>Contenido + campañas + automatización: una estrategia completa para tu negocio.</p>
          </div>

          <div className="ovit-footer__ctaActions">
            <a className="ovit-footer__btn ovit-footer__btn--primary" href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20iniciar%20mi%20estrategia%20digital.%20Me%20gustar%C3%ADa%20recibir%20una%20propuesta." target="_blank" rel="noopener noreferrer">
              Hablar por WhatsApp
            </a>
          </div>
        </div>

        {/* Main grid */}
        <div className="ovit-footer__main">
          {/* Brand */}
          <div className="ovit-footer__brand">
            <div className="ovit-footer__logo">
              <span className="ovit-footer__logoDot" aria-hidden="true" />
              <span className="ovit-footer__logoText">OVIT Soluciones Web</span>
            </div>

            <p className="ovit-footer__desc">
              Creamos contenido y campañas que generan ventas, y potenciamos tu negocio con
              landing pages, apps, bots en Messenger y automatizaciones con n8n.
            </p>

            <div className="ovit-footer__social">
              {/* Reemplaza los href por tus links reales */}
              <a
                className="ovit-social"
                href="https://www.facebook.com/devpweb/"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                title="Facebook"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M13.5 22v-8h2.7l.4-3.1h-3.1V9c0-.9.3-1.5 1.6-1.5h1.7V4.7c-.3 0-1.4-.1-2.6-.1-2.6 0-4.3 1.6-4.3 4.5v1.8H7.3V14h2.6v8h3.6z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div className="ovit-footer__col">
            <h4 className="ovit-footer__colTitle">Servicios</h4>
            <ul className="ovit-footer__links">
              <li><a href="#servicios">Contenido + Campañas</a></li>
              <li><a href="#servicios">Landing Pages / Web</a></li>
              <li><a href="#servicios">Apps tipo SaaS</a></li>
              <li><a href="#servicios">Agentes IA en Messenger</a></li>
              <li><a href="#servicios">Automatización con n8n</a></li>
            </ul>
          </div>

          {/* Navigation */}
          <div className="ovit-footer__col">
            <h4 className="ovit-footer__colTitle">Navegación</h4>
            <ul className="ovit-footer__links">
              <li><a href="#inicio">Inicio</a></li>
              <li><a href="#casos-exito">Casos Éxito</a></li>
              <li><a href="#formulario">Contacto</a></li>
              <li><a href="#faq">Preguntas</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="ovit-footer__col">
            <h4 className="ovit-footer__colTitle">Contacto</h4>

            <div className="ovit-footer__contact">

              <div className="ovit-footer__contactItem">
                <span className="ovit-footer__contactLabel">Correo</span>
                <span className="ovit-footer__contactValue">info@ovitsolucionesweb.com</span>
              </div>

              <a className="ovit-footer__miniBtn" href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20iniciar%20mi%20estrategia%20digital.%20Me%20gustar%C3%ADa%20recibir%20una%20propuesta." target="_blank" rel="noopener noreferrer">
                Enviar mensaje →
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="ovit-footer__bottom">
          <span>© {year} OVIT Soluciones Web. Todos los derechos reservados.</span>
          <span className="ovit-footer__bottomSep" aria-hidden="true">•</span>
          <a href="#privacidad">Políticas de Privacidad</a>
        </div>
      </div>
    </footer>
  );
}
